import PaidIcon from '@mui/icons-material/AttachMoney';
import UnpaidIcon from '@mui/icons-material/MoneyOff';

interface Props {
    isPaid: boolean
    isDraft: boolean
}

export default function PaidStatusIcon({ isPaid = false, isDraft = false }: Props) {
    return isPaid ? <PaidIcon color='success' /> : <UnpaidIcon htmlColor={isDraft ? 'secondary' : 'error'} />
}